document.addEventListener('DOMContentLoaded', function() {
  // Check if the device is mobile
  function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || 
           (navigator.userAgent.indexOf('IEMobile') !== -1) ||
           (window.innerWidth <= 768);
  }

  // Only proceed if not a mobile device
  if (!isMobileDevice()) {
    const style = document.createElement('style');
    style.textContent = `
      .bubble {
        position: absolute !important;
        border-radius: 50%;
        pointer-events: none !important;
        transform: translate(-50%, -50%);
        animation: bubble-float 1s ease-out forwards;
        z-index: 2147483647 !important;
        
        /* Enhanced realism */
        border: 0.5px solid rgba(0,0,0,0.08) !important;
        box-shadow: 
          0 0 1px rgba(255,255,255,0.8),
          0 0 3px rgba(200,230,255,0.6),
          inset 0 5px 10px rgba(255,255,255,0.8);
        filter: 
          drop-shadow(0 0 1px rgba(0,0,0,0.25))
          blur(0.4px) !important;
      }
      
      @keyframes bubble-float {
        0% { 
          transform: translate(-50%, -50%) scale(0.2) rotate(0deg);
          opacity: 0; 
          animation-timing-function: cubic-bezier(0.12, 0.66, 0.36, 1);
        }
        20% { 
          opacity: 0.9; 
          transform: translate(-50%, -50%) scale(0.8) rotate(5deg);
        }
        100% { 
          transform: translate(-50%, calc(-50% - 100px)) scale(1.1) rotate(10deg);
          opacity: 0; 
        }
      }
      
      /* Physically accurate bubble gradients */
      .bubble.type1 {
        background: radial-gradient(circle at 30% 30%, 
          rgba(255,255,255,0.95) 0%, 
          rgba(230,240,255,0.7) 40%, 
          rgba(210,230,255,0.3) 70%,
          rgba(190,220,255,0.1) 100%) !important;
      }
      .bubble.type2 {
        background: radial-gradient(circle at 25% 25%, 
          rgba(255,255,255,0.97) 0%, 
          rgba(240,248,255,0.75) 45%,
          rgba(220,240,255,0.4) 80%,
          transparent 100%) !important;
      }
      .bubble.type3 {
        background: radial-gradient(circle at 35% 35%, 
          rgba(255,255,255,0.98) 0%, 
          rgba(245,250,255,0.8) 50%,
          rgba(230,245,255,0.3) 90%,
          transparent 100%) !important;
      }
      
      /* Micro-bubble effects */
      .bubble::after {
        content: '';
        position: absolute;
        width: 20%;
        height: 20%;
        background: rgba(255,255,255,0.7);
        border-radius: 50%;
        top: 15%;
        left: 15%;
        filter: blur(0.5px);
      }
      
      html {
        position: relative !important;
        min-height: 100% !important;
      }
    `;
    document.head.appendChild(style);

    function createBubble(x, y) {
      const bubble = document.createElement('div');
      const bubbleType = Math.floor(Math.random() * 3) + 1;
      bubble.classList.add('bubble', `type${bubbleType}`);
      
      // Size-based physics
      const size = Math.random() * 15 + 5;
      bubble.style.width = `${size}px`;
      bubble.style.height = `${size}px`;
      
      // Organic shape variation
      bubble.style.borderRadius = `
        ${50 + Math.random() * 15}% 
        ${50 + Math.random() * 15}% 
        ${50 + Math.random() * 20}% 
        ${50 + Math.random() * 20}%`;
      
      // Size affects float speed and opacity
      const duration = 0.5 + (size/20); // Larger = slower
      bubble.style.opacity = 0.7 + (size/50); // Larger = more visible
      
      // Position with physical spread
      const scrollX = window.scrollX || window.pageXOffset;
      const scrollY = window.scrollY || window.pageYOffset;
      const offsetX = (Math.random() - 0.5) * (size * 3);
      const offsetY = (Math.random() - 0.5) * (size * 1.5) - 10;
      
      bubble.style.left = `${x + scrollX + offsetX}px`;
      bubble.style.top = `${y + scrollY + offsetY}px`;
      
      // Animation timing
      bubble.style.animationDuration = `${duration}s`;
      bubble.style.animationDelay = `${Math.random() * 0.1}s`;
      
      document.body.appendChild(bubble);
      
      // Create micro-bubbles (3-5 per bubble)
      const microBubbleCount = 3 + Math.floor(Math.random() * 3);
      for (let i = 0; i < microBubbleCount; i++) {
        createMicroBubble(x + scrollX, y + scrollY, size);
      }
      
      setTimeout(() => bubble.remove(), duration * 1000);
    }

    function createMicroBubble(x, y, parentSize) {
      const micro = document.createElement('div');
      micro.classList.add('bubble', `type${Math.floor(Math.random() * 3) + 1}`);
      
      const size = parentSize * (0.2 + Math.random() * 0.3);
      micro.style.width = `${size}px`;
      micro.style.height = `${size}px`;
      
      micro.style.borderRadius = `${40 + Math.random() * 30}% ${40 + Math.random() * 30}%`;
      micro.style.opacity = 0.4 + (Math.random() * 0.3);
      
      const offsetX = (Math.random() - 0.5) * parentSize;
      const offsetY = (Math.random() - 0.5) * parentSize;
      
      micro.style.left = `${x + offsetX}px`;
      micro.style.top = `${y + offsetY}px`;
      
      const duration = 0.3 + (Math.random() * 0.4);
      micro.style.animationDuration = `${duration}s`;
      micro.style.animation = `micro-float ${duration}s ease-out forwards`;
      
      document.body.appendChild(micro);
      setTimeout(() => micro.remove(), duration * 1000);
    }

    // Click handler
    document.addEventListener('click', function(e) {
      const bubbleCount = 6 + Math.floor(Math.random() * 4);
      for (let i = 0; i < bubbleCount; i++) {
        createBubble(e.clientX, e.clientY);
      }
    });

    // Touch handler for mobile (kept but won't be used on mobile due to the isMobileDevice check)
    document.addEventListener('touchend', function(e) {
      const touch = e.changedTouches[0];
      const bubbleCount = 4 + Math.floor(Math.random() * 3);
      for (let i = 0; i < bubbleCount; i++) {
        createBubble(touch.clientX, touch.clientY);
      }
    });
  }
});